import React, { useState } from "react";
import { Box, Card, Divider, Grid, Tab, Paper, Container } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import CommonTabs from "src/components/CommonTabs/CommonTabs";
import TabHeader from "src/components/TabHeader/TabHeader";
import { ConfigurationRoute } from "../../configuration.routes";
import { AddWarehouse } from "./components/AddWarehouse/AddWarehouse";
import { useStyles } from "./components/style";

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

type Props = {};

export default function Warehouse({}: Props): React.ReactElement {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const moduleName = ConfigurationRoute.title;
  const pageHeading = "Warehouse";

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={ConfigurationRoute.path} />
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={7}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item xs={4} md={3} lg={2} component={Card}>
                <div className="configTabs">
                  <CommonTabs value={value} handleChange={handleChange} tabMinHeight={800}>
                    <Tab label="Add a warehouse" {...a11yProps(1)} />
                  </CommonTabs>
                </div>
              </Grid>
              <Grid item xs={8} md={9} lg={10} component={Card} className={classes.tabCardContent}>
                <Container className="configSubTabs">
                  <AddWarehouse value={value} index={0} />
                </Container>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
